import * as braze from '@braze/web-sdk'

declare global {
  interface Window {
    braze: typeof braze | null;
  }
}

type BrazeTraits = {
  email?: string;
  role?: string;
  employerName?: string;
}

const getMetaContent = (name: string) =>
  document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content

export function initBraze () {
  const webSdkKey = getMetaContent('braze:web-sdk-key')
  const baseUrl = 'sdk.iad-02.braze.com'

  if (!webSdkKey) {
    window.braze = null
    return
  }

  const environment = getMetaContent('braze:environment') || 'development'

  try {
    window.braze = braze
    braze.initialize(webSdkKey, {
      baseUrl,
      enableLogging: environment !== 'production',
    })

    braze.openSession()
    braze.automaticallyShowInAppMessages()
  } catch (error) {
    window.braze = null
    console.error('Failed to initialize Braze:', error)
  }
}

export function identifyBrazeUser (userId: string, traits: BrazeTraits = {}) {
  if (!window.braze) return

  try {
    window.braze.changeUser(userId)
    window.braze.openSession()

    const user = window.braze.getUser()
    if (!user) return

    if (traits.email) user.setEmail(traits.email)
  } catch (error) {
    console.error('Failed to identify Braze user:', error)
  }
}
